<template><!--报警对象筛选-->
<div class="pb2x">
	<div v-if="!type" class="posR drop-list-box hasDropList-focus w20x-min w40x-max">
		<!--  @mouseleave="closeDrop" -->
		 <!--v-show="type!=1"  -->
		<InputText class="w100pct dpIB" :max-length="50" :placeholder="$t('fill3rd111',[getLanguageStr('word1854','选择电站'),'点击{0}'])" @Click="getStructure" v-model="station.searchKey" :readonly="true" :clearBtn="true" @AfterClear="reset(true)"></InputText>
		<div class="mt05x bdSub boxR-light" v-if="flag">
			<div class="pt05x pb05x taC inputWrap bdSub-bottom">
				<InputText v-model="station.searchText" class="w80pct dpIB bgContent" name="alarmStationSearch" :placeholder="getLanguageStr('phrase870','请输入电站名称')" :clearBtn="true" ref="searchBox" :searchBtn="true" :fn="getStationList" @AfterClear="getStationList"></InputText>
			</div>
			<div class="bdSub-bottom pl2x inputWrap lh20">
				{{station.searchKey?station.searchKey:getLanguageStr('word1570','全部电站')}}
			</div>
			<div class="posR">
				<Loading v-show="station.loading"></Loading>
				<div class="h20x-max pl2x lh20 ofH" scroll v-show="station.result.length">
					<ul>
						<li v-for="(item,index) in station.result" :key="index"><a @click="getStation(item.id,item.name)">{{item.name}}</a></li>
						<!-- <li v-for="(item,index) in station.result" :key="index"><a :title="item.title" @click="getStationList(item)">{{item.title}}</a></li> -->
					</ul>
				</div>
				<div class="no-data" v-show="!station.result.length">
					{{$t('word1380',['暂无数据'])}}
				</div>
			</div>
		</div>
	</div>
	<div class="posR drop-list-box  w20x-min w30x-max" v-show="fromW?true:station.selected.id" :class="fromW?'fL':'mt05x'" @mouseenter="showMousePos=true" @mouseleave="showMousePos=false" v-clickoutside="handleClose">
		 <!--device.show || type==1  @mouseleave="closeDeviceDrop" -->
			<transition-group tag="div" class="enableList bdSub boxR-light cb tra ml05x_E mt05x_E fL_E" :class="{pr3x:device.selectedId.length>0,pr1x:device.selectedId.length==0}" v-on:leave="el=>{transitionAction(el,'hide-x');}" :duration="500">
			<button v-if="device.selectedId.length>0" class="clearTag hover-f-error hover-effect-rotate tra-fast" :key="'clear'" @click="clear" type="button"><div class="icoSys w1x h1x bgSub fSub fs16x"><Icon name="no" /></div></button>
			<TagBox v-if="device.isSelect" v-for="(device,index) in device.selectedId" :key="index" :styleType="'tag'" :val="device.name?device.name:getTypeText(device.type,'deviceType')+device.serialNumber" :data="device" @Remove="onRemove(device.id,index)"></TagBox>
			<button :key="'add'" class="lh15 cMain" type="button" @click="getDevice">{{'+'+getLanguageStr('word164','设备')}}</button>
		</transition-group>
		<div class="mt05x bdSub boxR-light" :class='{"custcss":fromW}' v-if="device.flag">
			<div class="pt05x pb05x taC inputWrap bdSub-bottom">
				<InputText class="w80pct dpIB bgContent" :placeholder="getLanguageStr('phrase523','请输入')+'SN'" name="alarmSearchSn" :clearBtn="true" ref="searchSn" :searchBtn="true" v-model="device.sn" :fn="getDeviceList" @AfterClear="getDeviceList"></InputText>
			</div>
			<div class="bdSub-bottom pl2x inputWrap lh20">
				<span v-if="!targetId">{{station.searchKey?station.searchKey:getLanguageStr('word1570','全部电站')}}</span>
				<span v-if="device.deviceListShow"><span class="dpIB fs16x fa tra-fast fa-angle-left cSub mr1x curP" @click="device.deviceListShow=false"></span>{{device.deviceSelect.title}}</span>
			</div>
			<div class="h12x-min h22x-max posR" >
				<Loading v-show="device.loading"></Loading>
				<!-- <div class="h20x-max" scroll v-show="btnGroup_equipment.length && !device.deviceListShow">
					<ul>
						<li v-for="(item,index) in btnGroup_equipment" :key="index" class="inputWrap clearfix pl2x pr2x curP" @click="getAllDevice(item)">
							<span>{{item.title}}</span>
							<span class="dpIB fs16x fR fa tra-fast fa-angle-right cSub"></span>
						</li>
					</ul>
				</div> -->
				<div class="h20x-max lh20" v-show="device.DeviceList.length" scroll>
					 <ul>
						<li class="inputWrap pl2x pr2x"><Checkbox :text="getLanguageStr('cmd19','全部')" :data="device.DeviceList" :keyMap="'isSelect'" @Click="selectData"></Checkbox></li>
						<li v-for="(item,index) in device.DeviceList" :key="index" class="inputWrap clearfix pl2x pr2x">
							<Checkbox v-model="item.isSelect" :text="(item.name?item.name:getTypeText(item.type,'deviceType'))+item.serialNumber" :index="item.id" @Click="selectData(item.isSelect,index)"></Checkbox>
						</li>
					</ul>
				</div>
				<!--
				<div v-if="device.DeviceList.length" class="pl2x pt05x pb05x">{{getLanguageStr('word56','已选')}}{{device.selectedId.length}}/{{device.DeviceList&&device.DeviceList.length < max ? device.DeviceList.length:max}}</div>
				 -->
				<div v-if="device.DeviceList.length" class="pl2x pt05x pb05x">{{getLanguageStr('word56','已选')}}{{device.selectedId.length}}/{{max}}</div>
				<div class="no-data cSub taC pt2x" v-show="!device.DeviceList.length && !device.loading">
					{{$t('word1380',['暂无数据'])}}
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import InputText from '@/components/common/ui/InputText.vue';
import VTree from '@/components/common/ui/vTree/Tree';
import Loading from '@/components/common/ui/Loading';
import TagBox from '@/components/common/ui/TagBox';
import Checkbox from '@/components/common/ui/Checkbox.vue';
import clickoutside from '@/plugins/clickOutSide/index.js';
import * as stationApi from '@/api/maintain/plant/list.js';
import * as lib from '@/util/lib';
import {getLanguageStr} from '@/util/language';
let timer = null;
let closeDropTimer = null;
export default {
	name: 'AlarmStation',
	directives: {clickoutside},
	props: {
		filter: {
			type: Object,
			default: {}
		},
		type: {// 1:电站；2:设备
			type: Number,
			default: null
		},
		targetId: {// 对象id，用于锁定针对某对象的操作
			type: Number,
			default: null
		},
		fromW: {
			type: Boolean, // 用于分辩是否来自维保记录
			default: false
		},
		max: {// 最大可选择数量
			type: Number,
			default: 50
		},
		powerTypeList: {
			type: Array,
			default: undefined
		}
	},
	components: {InputText, Loading, Checkbox, TagBox},
	data () {
		return {
			flag: false,
			station: {
				selected: {id: this.targetId, name: ''},
				searchText: '',
				searchKey: '',
				result: [],
				loading: false
			},
			device: {
				selectedId: [],
				show: false, // 整体
				list: {}, // 总数据索引
				flag: false,
				sn: '',
				loading: true,
				DeviceList: [],
				deviceListShow: false,
				deviceSelect: '',
				selectAllStatus: 0
			},
			btnGroup_equipment: []
		};
	},
	computed: {
	},
	watch: {
		// device: {
		// 	handler: function (v) {

		// 	},
		// 	deep: true
		// }
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		transitionAction: lib.transitionAction,
		handleClose (e) {
		 if (!this.showMousePos) {
				this.device.flag = false;
			}
		},
		show (data) {
			// 请注意该分支来自维保记录里面的组件
			if (JSON.stringify(this.filter) == '{}') {
				this.station.selected.id = this.targetId;
				if (data) {
					this.getDevice();
					this.device.selectedId = data;
					this.$nextTick(() => {
						 this.device.flag = false;
					});
				}
			} else {
				this.$nextTick(() => {
					if (!this.filter.plantIdList.active.length) {
							 this.reset();
					} else {
						//  if(this.type==1){
						//     this.station.selected={id:this.filter.plantIdList.active[0]}
						// }
					}
					if (!this.filter.deviceIdList.active.length) {
						this.device = {
							selectedId: [],
							show: false,
							list: [],
							flag: false,
							sn: '',
							loading: true,
							DeviceList: [],
							deviceListShow: false,
							deviceSelect: '',
							selectAllStatus: 0
						};
					}
				});
			}
		},
		reset (emit = false) {
			this.station = {
				selected: {id: this.targetId, name: ''},
				searchText: '',
				searchKey: '',
				result: [],
				loading: false
			};
			this.device = {
				selectedId: [],
				show: false,
				list: [],
				flag: false,
				sn: '',
				loading: true,
				DeviceList: [],
				deviceListShow: false,
				deviceSelect: '',
				selectAllStatus: 0
			};
			this.flag = false;
			lib.setScroll($(this.$el).find('[scroll]'));
			this.closeDrop();
			if (emit == true) this.$emit('Update', this.station.selected, this.device.selectedId);
		},
		closeDrop () {
			let $this = this;
			closeDropTimer = setTimeout(function () {
				$this.flag = false;
			}, 50);
		},
		closeDeviceDrop () {
			let $this = this;
			closeDropTimer = setTimeout(function () {
				$this.device.flag = false;
			}, 50);
		},
		getStationList () {
			this.station.loading = true;
			let request = {
				page: 1,
				size: 100, // 一万条会超时
				'order.direction': 'ASC',
				'order.property': 'name'
			};
			stationApi.apiGetList(request, {name: this.station.searchText, powerTypeList: this.powerTypeList}).then(res => {
				lib.fillHeight();
				lib.setScroll($(this.$el).find('[scroll]'));
				this.station.loading = false;
				this.station.result = res.data;
			}, error => {
				this.station.loading = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		getStation (id, name) {
			this.station.searchKey = name;
			this.station.selected = {id, name};
			this.flag = false;
			// this.device.show=true
			this.device = {
				selectedId: [],
				show: true,
				list: [],
				flag: false,
				sn: '',
				loading: true,
				DeviceList: [],
				deviceListShow: false,
				deviceSelect: '',
				selectAllStatus: 0
			};
			this.$emit('Update', this.station.selected, this.device.selectedId);
		},
		getStructure () {	// 打开下拉时执行，输入搜索时直接执行getListByKey
			this.flag = !this.flag;
			// let buttonPermissions = JSON.parse(localStorage.getItem('buttonPermissions'))
			if (this.flag) {	// 只有flag==flase的情况下查询
				// if(buttonPermissions.includes('A/B/A13')){
				this.device.flag = false;
				this.getStationList();
				// this.GetStructure().then( () => {
				// 	this.loading=false
				// 	this.currentGroup = this.groupStructure[0]
				// 	this.groupStructure.forEach((data,index) => {
				// 		if(index == 0){
				// 			this.$set(data,'selected',true)
				// 		}else{
				// 			this.$set(data,'selected',false)
				// 		}
				// 		this.$set(data,'expanded',true)
				// 		this.$set(data,'title', data.name)
				// 	})
				// 	let arr = tree.toTree(this.groupStructure)
				// 	this.treeData  = _.cloneDeep(arr)

				// 	if(this.readonly) return
				// 	if (!this.flag) {
				// 		this.flag = true;
				// 		if (!this.searchKey) {	//无搜索词
				// 			this.getUserList({
				// 				"page": 1,
				// 				"size": 100,
				// 				"order.direction": "DESC",
				// 				"order.property": "id",
				// 				"selectGroupId": this.currentGroup.id,
				// 				"markName":""
				// 			})
				// 		}else {	//有搜索词
				// 			this.loading=false	//提前loading(getListByKey有延时)
				// 			this.getListByKey()
				// 		}
				// 	}
				// }).catch(error => {
				// 	!_.isEmpty(error) && this.$notify(error)
				// })
				// }else{
				// 	if(!this.flag){
				// 		this.flag=true
				// 		this.loading=false
				// 		this.result=[]
				// 	}
				// }
			}
		},
		_getSummary (endfn) {
			this.device.loading = true;
			stationApi.StationSummary(this.station.selected.id, {systemId: null}).then(res => {
				this.device.loading = false;
				const {collectorCount, inverterCount, meterCount, pvModuleCount, weatherStationCount, microInverterCount, combinerBoxCount, repeaterCount, batteryCount, dtuCount, apiCount, fanCount} = res;
				const btnState = [
					{title: getLanguageStr('word35', '逆变器'), api: 'OperationInverter', childRef: 'InverterList', count: inverterCount.total},
					{title: getLanguageStr('word39', '电表'), api: 'OperationAmmeter', childRef: 'AmmeterList', count: meterCount.total},
					{title: getLanguageStr('word647', '组件'), api: 'OperationComponet', childRef: 'ComponetList', count: pvModuleCount ? (pvModuleCount.total || 0) : 0},
					{title: getLanguageStr('word38', '气象站'), api: 'OperationWeather', childRef: 'WeatherList', count: weatherStationCount.total},
					{title: getLanguageStr('word804', '微逆'), api: 'OperationMicroInverter', childRef: 'MicroInverterList', count: microInverterCount.total},
					{title: getLanguageStr('word36', '汇流箱'), api: 'OperationCombinerBox', childRef: 'CombinerBoxList', count: combinerBoxCount.total},
					{title: getLanguageStr('word803', '中继器'), api: 'OperationRepeater', childRef: 'RepeaterList', count: repeaterCount.total},
					{title: getLanguageStr('word37', '电池'), api: 'OperationBattery', childRef: 'BatteryList', count: batteryCount.total},
					{title: getLanguageStr('word34', '采集器'), api: 'OperationCollector', childRef: 'CollectorList', count: collectorCount.total},
					{title: getLanguageStr('DTU', 'DTU'), api: 'OperationDTU', childRef: 'DTUList', count: dtuCount.total},
					{title: getLanguageStr('API', 'API'), api: 'OperationAPI', childRef: 'APIList', count: apiCount.total},
					{title: getLanguageStr('FAN', 'FAN'), api: 'OperationFAN', childRef: 'FANList', count: fanCount.total}
				];
				this.btnGroup_equipment = btnState.filter(el => el.count > 0);
				if (endfn)endfn();
			}, error => {
				 this.device.loading = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		getDevice () {
			if (!this.device.flag) {
				this.device.flag = true;
				this._getSummary(() => {
					this.getDeviceList();
				});
			}
		},
		async getDeviceList () {
			let req = {
				page: 1,
				size: 500,
				'order.direction': 'ASC',
				'order.property': 'name',
				sn: this.device.sn
			};
			if (this.btnGroup_equipment.length) {
				this.device.loading = true;
				this.device.DeviceList = [];
				const pokemonPromises = this.btnGroup_equipment.map(entry => {
					return stationApi[entry.api](this.station.selected.id, req);
				});
				const results = await Promise.all(pokemonPromises);
				lib.fillHeight();
				lib.setScroll($(this.$el).find('[scroll]'));
				let resultArr = [];
				results.forEach((el, index) => {
					resultArr.push(...el.data);
					// $.each(el.data,(i,v)=>{//登记总列表
					//   this.device.list[String(v.id)]=v;
					// });
				});
				this.device.DeviceList = resultArr.map(el => ({
					name: el.name ? el.name : this.getTypeText(el.type, 'deviceType'),
					id: el.id,
					isSelect: false,
					serialNumber: el.serialNumber,
					type: el.type
				}));
				if (!this.fromW) {
					if (this.filter.deviceIdList.active.length > 0) { // 如果父级有设备id传过来
						this.filter.deviceIdList.active.forEach((el) => {
							this.device.DeviceList.forEach(item => {
								if (el.id == item.id) {
									item.isSelect = true;
								}
							});
						});
					}
				} else {
					if (this.device.selectedId.length > 0) {
						this.device.selectedId.forEach((el) => {
							this.device.DeviceList.forEach(item => {
								if (el.id == item.id) {
									item.isSelect = true;
								}
							});
						});
					}
					if (this.device.selectedId.length == this.device.DeviceList.length) {
						this.device.selectAllStatus = 2;
					} else if (this.device.selectedId.length == 0) {
						this.device.selectAllStatus = 0;
					} else {
						this.device.selectAllStatus = 1;
					}
				}
				this.device.loading = false;
			}
		},
		getAllDevice (item) {
			this.device.deviceSelect = item;
			this.getDeviceList(item);
		},
		selectData (val, index) {
			if (this.device.selectedId.length < this.max || val == false) {
				if ($.type(val) == 'boolean' && index >= 0) {
					// this.device.DeviceList[index].isSelect=val;
				} else if (index == 'all') {
					let cont = this.device.selectedId.length;
					$.each(this.device.DeviceList, (index, el) => { // 进行批量设置
						if (cont < this.max) {
							// this.$set(el, 'isSelect', val);
							if (el.isSelect != val) {
								el.isSelect = val;
								if (el.isSelect) { // 针对选中的进行计数
									++cont;
								}
							}
						} else { // 超出最大数
							this.$notify(i18n.t('fill3rd75', [this.max, '选择的数量不能超过{0}']));
							return false;
						}
					});
				}
				this.selectedData();
			} else {
				this.$nextTick(() => {
					if ($.isNumeric(index)) this.device.DeviceList[index].isSelect = false;
				});
				this.$notify(i18n.t('fill3rd75', [this.max, '选择的数量不能超过{0}']));
			}
		},
		selectedData () {
			// this.device.selectedId = this.device.DeviceList.filter(el => el.isSelect);//这样处理会导致仅保存筛选的勾选结果
			let selectIdMap = {};
			$.each(this.device.selectedId, (index, val) => {
				selectIdMap[String(val.id)] = val;
			});
			let tempList = this.device.DeviceList.filter(el => el.isSelect);
			let i = 0;
			while (i < tempList.length) {
				if (selectIdMap[String(tempList[i].id)]) {
				} else { // 没有记录则添加进已选
					this.device.selectedId.push(tempList[i]);
				}
				++i;
			};
			tempList = this.device.DeviceList.filter(el => !el.isSelect);
			i = 0;
			while (i < tempList.length) { // 遍历已取消的
				$.each(this.device.selectedId, (index, val) => { // 找出需要剔除的
					if (val.id == tempList[i].id) {
						this.device.selectedId.splice(index, 1);
						--i;
						return false;
					}
				});
				++i;
			};

			// let $this = this
			// $.each(this.device.selectedId, function (index) { //处理已选择的设备名称+sn
	 //      $this.device.selectedId[index] = $.extend(true, {}, this, {name: this.name + this.serialNumber})
			// });
			//			if (this.device.selectedId.length == this.device.DeviceList.length) {
			//      this.device.selectAllStatus = 2
			//    } else if (this.device.selectedId.length == 0) {
			//      this.device.selectAllStatus = 0
			//    } else{
			//      this.device.selectAllStatus = 1
			//    }

			this.$emit('Update', this.station.selected, this.device.selectedId);
			// this.$emit('UpdateObj',this.device.selectedId)
		},
		clear () {
			this.device.selectedId = [];
			this.device.DeviceList.forEach(el => {
				this.$set(el, 'isSelect', false);
			});
			this.selectedData();
		},
		onRemove (id, index) {
			this.device.DeviceList.forEach((el, index) => {
				if (el.id === id) {
					 this.device.DeviceList[index].isSelect = false;
				}
			});
			this.selectedData();
		}
	},
	mounted () {
		lib.fillHeight();
		lib.setScroll($(this.$el).find('[scroll]'));
	}
};
</script>
<style lang="scss" scoped>
.enableList{padding:{bottom:.5em;};position:relative;
	.clearTag{position:absolute;top:0;right:.5em;}
}
.custcss{
	position: absolute;
		z-index: 10003;
		background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/alarm/part/AlarmStation.vue